import {
    DownloadControlActions,
    LabelOptions,
} from '../../models/configuration/explorer/DownloadControls';
import { ScreenSizeStore, QueryStore, EntityStore } from '../../stores';

export function isDropdownEnabled(
    screenSizeStore: ScreenSizeStore,
    downloadControlActions: DownloadControlActions
) {
    if (downloadControlActions && downloadControlActions.dropdownOptions) {
        const { showBreakpoints = [] } = downloadControlActions.dropdownOptions;
        if (showBreakpoints && showBreakpoints.length > 0) {
            return showBreakpoints.some(({ breakpoint, operator }) =>
                screenSizeStore.compareBreakpoints(
                    screenSizeStore.breakpointSize,
                    operator,
                    breakpoint
                )
            );
        }
        return false;
    }
    return false;
}

interface IsOptionLabelHiddenProps {
    downloadControlActions: DownloadControlActions;
    labelOptions?: LabelOptions;
    screenSizeStore: ScreenSizeStore;
}
export function isOptionLabelHidden(props: IsOptionLabelHiddenProps) {
    const { downloadControlActions, labelOptions, screenSizeStore } = props;
    if (labelOptions) {
        if (Boolean(labelOptions?.hide)) {
            return true;
        }

        const isDropdown = isDropdownEnabled(
            screenSizeStore,
            downloadControlActions
        );
        if (
            (labelOptions?.hideWhen === 'inline' && !isDropdown) ||
            (labelOptions?.hideWhen === 'dropdown' && isDropdown)
        ) {
            return true;
        }
    }
    return false;
}

interface GetOptionLabelProps {
    defaultLabel?: string;
    document?: any;
    downloadControlActions: DownloadControlActions;
    labelOptions?: LabelOptions;
    entityStore?: EntityStore;
    labelKey: 'label' | 'disabledLabel' | 'successLabel';
    screenSizeStore: ScreenSizeStore;
    skipHiddenCheck?: boolean;
    queryStore: QueryStore;
}
export function getOptionLabel(props: GetOptionLabelProps): string | undefined {
    const {
        defaultLabel,
        document,
        downloadControlActions,
        labelOptions,
        entityStore,
        labelKey,
        screenSizeStore,
        skipHiddenCheck,
        queryStore,
    } = props;

    if (labelOptions) {
        if (
            skipHiddenCheck !== true &&
            isOptionLabelHidden({
                downloadControlActions,
                labelOptions,
                screenSizeStore,
            })
        ) {
            return;
        }

        if (labelOptions[labelKey]) {
            const labelQuery = labelOptions[labelKey];
            return queryStore.queryOrDefault(
                labelQuery,
                {
                    entityByType: {
                        [labelQuery.entityType]: {
                            ...entityStore?.value,
                        },
                    },
                    document,
                },
                defaultLabel
            );
        }
    }
    return defaultLabel;
}



// WEBPACK FOOTER //
// ./src/utils/document/downloadControls.ts